import { JSX, useEffect, useState } from "react";

import { SearchAddress } from "./models/searchAddress";
import { BasicState } from "@app/geography";
import GeographyService from "@app/geography/geographyService";

interface AddressSearchBarProps {
  address: SearchAddress;
  onKeyUp: (e: React.KeyboardEvent) => void;
  onSearchChange: (e: React.ChangeEvent) => void;
  onSelectChange: (e: React.ChangeEvent) => void;
}

export default function AddressSearchBar(props: AddressSearchBarProps): JSX.Element {
  const [states, setStates] = useState<BasicState[]>([]);

  useEffect(() => {
    const geoService = new GeographyService();
    geoService.getStatesForDroplist().then((states) => setStates(states));
  }, []);

  return (
    <div className="row mb-2">
      <div className="col-sm-3">Street Address
        <input className="form-control" placeholder="Street Address" value={props.address.address1} onKeyUp={props.onKeyUp} onChange={props.onSearchChange} name="address1" />
      </div>
      <div className="col-sm-auto">Address 2
        <input className="form-control" placeholder="Address 2" value={props.address.address2} onKeyUp={props.onKeyUp} onChange={props.onSearchChange} name="address2" />
      </div>
      <div className="col-sm-2">City
        <input className="form-control" placeholder="City" value={props.address.city} onKeyUp={props.onKeyUp} onChange={props.onSearchChange} name="city" />
      </div>
      <div className="col-sm-auto">State
        <select className="form-control" name="state" value={props.address.state} onChange={props.onSelectChange}>
          <option value=""></option>
          {states.map((state, index) => { return <option key={index} value={state.abbreviation}>{state.abbreviation}</option> })}
        </select>
      </div>
      <div className="col-sm-2">Zip Code
        <input className="form-control" placeholder="Zip Code" value={props.address.zip} onKeyUp={props.onKeyUp} onChange={props.onSearchChange} name="zip" />
      </div>
    </div>
  );
}